// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS. A repo oxlint konfigja a TS+build világra
 * van hangolva (stdlib/common wrapperek, no-semicolon, arrow-tiltás), ami itt
 * nem alkalmazható és valódi hibát nem fog (a correctness kategória eleve off).
 * Ezért erre a szigetre kikapcsoljuk. Ha később build kerül fölé, a fájlt
 * TS-re érdemes konvertálni és ezt a sort törölni. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – YouTube „facade" (lite-embed) blokk.
 *
 * A window.TUDASFM_YOUTUBE listából előnézeti kártyákat renderel: alapból CSAK a
 * thumbnail töltődik (kép), semmilyen YouTube iframe/JS. Kattintásra egy modal
 * ablakban jön be a tényleges lejátszó (youtube-nocookie beágyazás, autoplay).
 * Bezáráskor az iframe megszűnik, így a lejátszás azonnal leáll.
 *
 * Nincs külső függőség, nincs build; klasszikus <script>-ként fut.
 */
function initYoutube() {
  const grid = document.getElementById('youtube-grid');
  const modal = document.getElementById('yt-modal');
  const player = document.getElementById('yt-modal-player');

  if (grid === null || modal === null || player === null) {
    return;
  }

  const videos = window.TUDASFM_YOUTUBE || [];

  // A kártyát megnyitó elem, hogy bezárás után visszaadhassuk neki a fókuszt.
  let lastTrigger = null;

  const closeModal = () => {
    // Az iframe eltávolítása azonnal leállítja a lejátszást.
    player.replaceChildren();
    modal.hidden = true;
    document.body.classList.remove('yt-modal-open');
    if (lastTrigger !== null) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  };

  const openModal = (video, trigger) => {
    lastTrigger = trigger;

    const iframe = document.createElement('iframe');
    iframe.className = 'yt-modal__iframe';
    iframe.src = `https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0&playsinline=1`;
    iframe.title = video.title;
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');

    player.replaceChildren(iframe);
    modal.hidden = false;
    document.body.classList.add('yt-modal-open');

    const closeButton = modal.querySelector('.yt-modal__close');
    if (closeButton !== null) {
      closeButton.focus();
    }
  };

  const buildCard = (video) => {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'yt-card';
    card.setAttribute('aria-label', `Videó lejátszása: ${video.title}`);

    const thumb = document.createElement('img');
    thumb.className = 'yt-card__thumb';
    thumb.loading = 'lazy';
    thumb.width = 480;
    thumb.height = 270;
    thumb.alt = '';
    thumb.src = `https://i.ytimg.com/vi/${video.id}/maxresdefault.jpg`;
    // maxresdefault nem mindig létezik → visszaesés a mindig meglévő hqdefault-ra.
    thumb.addEventListener('error', () => {
      const fallback = `https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`;
      if (thumb.src !== fallback) {
        thumb.src = fallback;
      }
    });

    const play = document.createElement('span');
    play.className = 'yt-card__play';
    play.setAttribute('aria-hidden', 'true');
    play.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z" /></svg>';

    // A thumbnail + lejátszás gomb közös, pozicionált konténerben, hogy a gomb
    // pontosan az előnézeti képre kerüljön (ne a cím miatt eltolódva).
    const media = document.createElement('span');
    media.className = 'yt-card__media';
    media.append(thumb, play);

    const title = document.createElement('span');
    title.className = 'yt-card__title';
    title.textContent = video.title;

    card.append(media, title);
    card.addEventListener('click', () => openModal(video, card));

    return card;
  };

  grid.replaceChildren(...videos.map(buildCard));

  // Bezárás: bármely [data-close] elem (backdrop, × gomb) kattintására.
  modal.querySelectorAll('[data-close]').forEach((element) => {
    element.addEventListener('click', closeModal);
  });

  // Bezárás Escape-re, csak amíg nyitva van a modal.
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.hidden === false) {
      closeModal();
    }
  });
}

initYoutube();
